/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Popup_BlockedInputs */



/**
* | output |
* | --- |
* | "Please allow popups for this site to sign in with Google." |
*
* @param {Login_Error_Popup_BlockedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_popup_blocked = /** @type {((inputs?: Login_Error_Popup_BlockedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Popup_BlockedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez autoriser les pop-ups pour ce site afin de vous connecter avec Google.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte erlauben Sie Pop-ups für diese Website, um sich mit Google anzumelden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si prega di consentire i popup per questo sito per accedere con Google.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, разрешите всплывающие окна, чтобы авторизоваться на этом сайте через Google.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Permita las ventanas emergentes en este sitio para iniciar sesión con Google.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请允许此网站弹出窗口，以便使用 Google 帐户登录。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Google でサインインするには、このサイトのポップアップを許可してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया इस साइट पर Google से साइन इन करने के लिए पॉपअप की अनुमति दें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, permita pop-ups para este site para fazer login com o Google.")
	return /** @type {LocalizedString} */ ("Please allow popups for this site to sign in with Google.")
});